import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class AppUnsubscribeApi {
	constructor(private http: HttpClient) {}

	query(key: string) {
		const payload = {
			key: key,
			init: true,
		};
		return this.http.post('/public/json/app/unsubscribe/query', payload);
	}

	action(action: string, key: string) {
		const payload = {
			action: action,
			key: key,
		};
		return this.http.post('/public/json/app/unsubscribe/action', payload);
	}
}
